<template>
  <div class="w-100 d-flex align-items-center" :class="dynamicClass">
    <span class="material-icons md-18" :class="{ 'is-checked': content }">{{ icon }}</span>
  </div>
</template>

<script>
export default {
  name: 'CheckBoxField',
  props: {
    content: {
      type: [Number, Boolean],
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClass() {
      return this.inDetailView || this.isCardView ? 'justify-content-start negate-gap' : 'justify-content-center'
    },
    icon() {
      return this.content ? 'check_box' : 'check_box_outline_blank'
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
  },
}
</script>

<style lang="scss" scoped>
.negate-gap {
  margin-inline-start: -3px;
}
</style>
